export * from '@platform/services/splash-screen/public-api';
